import Blink from '@components/Blink'
import useTracking from '@hooks/useTracking'
import { MoreAboutItem as MoreAboutItemType } from '@widgets/MoreAbout/types'
import { FunctionComponent, useCallback } from 'react'
import styled, { css } from 'styled-components'
import Catchword from './Catchword'
import ImageOverlayWrapper from './ImageOverlayWrapper'
import ImageWrapper from './ImageWrapper'
import TeaserImage from './TeaserImage'
import TextWrapper from './TextWrapper'
import Title from './Title'
import VideoInfoBig from './VideoInfoBig'
import config from '@config'
import usePageMetadata from '@hooks/usePageMetadata'

const {
  backend: { baseUrl },
} = config
interface ItemWrapperProps {
  isVideoOnly: boolean
}

const ItemWrapper = styled(Blink)<ItemWrapperProps>`
  ${({
    theme: {
      colors: {
        white,
        blicktvGrey: { btvGrey_60 },
      },
    },
    isVideoOnly,
  }) => css`
    scroll-snap-align: start;
    scroll-snap-stop: always;
    text-decoration: none;
    display: grid;
    height: 85px;
    width: 255px;
    overflow: hidden;
    grid-template-columns: 85px 160px;
    grid-gap: 8px;
    background-color: ${isVideoOnly ? btvGrey_60 : white};
  `}
`

const MoreAboutItem: FunctionComponent<MoreAboutItemType> = ({
  catchword,
  targetContentType,
  title,
  image = {
    src: '/incoming/31574-v2-missing.png',
    alt: 'image not found',
  },
  link,
}) => {
  const { src: imageSrc, alt: imageAlt, crops: imageAvailableCrops } = image
  const isVideoOnly = targetContentType === 'video'
  const pageMetadata = usePageMetadata()
  const articleId = pageMetadata?.id

  const trackingOnClick = useCallback(() => {
    return {
      event: 'click_mehrZumThema',
      eventCategory: 'related content',
      eventLabel: `${baseUrl}/id${articleId}.html`,
      eventAction: 'mehrZumThema',
    }
  }, [articleId])

  const trackOnClick = useTracking(trackingOnClick)

  const blinkProps = {
    ...link,
    onClick: trackOnClick,
  }

  return (
    <ItemWrapper isVideoOnly={isVideoOnly} {...blinkProps}>
      <ImageWrapper>
        <TeaserImage
          src={imageSrc}
          alt={imageAlt}
          availableCrops={imageAvailableCrops}
        />
        <ImageOverlayWrapper>
          {isVideoOnly ? <VideoInfoBig /> : null}
        </ImageOverlayWrapper>
      </ImageWrapper>
      <TextWrapper>
        {catchword ? (
          <Catchword isVideoOnly={isVideoOnly}>{catchword}</Catchword>
        ) : null}
        <Title isVideoOnly={isVideoOnly}>{title}</Title>
      </TextWrapper>
    </ItemWrapper>
  )
}

export default MoreAboutItem
